const PontoTipoEnum = {
    FORTE: 1,
    DESENVOLVER: 2
}

export default PontoTipoEnum;